import { useEventBus } from "@vueuse/core";

export default function useEmitter() {
  return {
    ctaClickBus: useEventBus<HTMLElement>('form:validation:fail'),
    formValidationFailedBus: useEventBus('form:goto'),
    openChatboxBus: useEventBus('chatbox:open')
  };
}